import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import BreadcrumbBg from '../img/banner/breadcrumb-bg.jpg'
import HeaderSecond from '../HeaderSecond';
import axios from '../axios'
import EventImg from '../img/events/event-view.jpg';
import NoEventImage from '../img/events/no-events.png';
import { ToastContainer, toast } from 'react-toastify';
import ShareEvent from '../Event/ShareEvent';
import LoaderImg from '../img/logo/running.gif'
import EventView from '../../src/img/events/event-view.jpg'

const ShowWishlist = (props) => {
    const navigate = useNavigate();
    const [Index, setIndex] = useState(5);
    const [UserEventsFollow, setUserEventsFollow] = useState([]);
    const [TotalUserEventFollow, setTotalTotalUserEventFollow] = useState(0);
    const [ApiCall, setApiCall] = useState(true);
    const [Loader, setLoader] = useState(false);

    localStorage.removeItem('EventId');
    localStorage.removeItem('EventType');
    const [Login, setLogin] = useState(false);
    const [ShareEventFlag, setShareEventFlag] = useState(false);
    const [EventName, setEventName] = useState('');
    const [EventIdShareEvent, setEventIdShareEvent] = useState('');
    const handleShareEvent = (eventId, eventName) => {
        setShareEventFlag(true);
        setEventName(eventName);
        setEventIdShareEvent(eventId);
    }

    useEffect(() => {
        if (ApiCall) {
            setLoader(true);
            axios.post("userfollowevent", {})
                .then((response) => {
                    // console.log("response:-",response.data.data.userfollowevent);
                    if (response.data.data.hasOwnProperty('userfollowevent')) {
                        setUserEventsFollow(response.data.data.userfollowevent);
                    } else {
                        setUserEventsFollow([]);
                    }
                    setTotalTotalUserEventFollow(response.data.data.userfollowevent ? response.data.data.userfollowevent.length : 0)
                    setApiCall(false);
                    setLoader(false);
                })
                .catch((error) => {
                    console.log(error);
                    setLoader(false);
                })
        }
    }, [ApiCall])

    const handleWishList = (eventId, is_follow) => {
        // alert("here");
        // is_follow == 0 then need to follow means add entry in table
        // is_follow == 1 then need to unfollow means delete the entry form table
        const RacesToken = localStorage.getItem("RacesToken") ? localStorage.getItem("RacesToken") : "";
        if (RacesToken) {
            const payload = {
                "event_id": eventId,
                "is_follow": is_follow
            }
            axios.post("/follow", payload)
                .then((response) => {
                    // console.log(response.data.message);
                    if (response.status) {
                        toast.error(response.data.message);
                        setApiCall(true);
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        console.log('Error occured while adding to wishlist')
                    }
                })
        } else {
            // const CountryCode = localStorage.getItem("CountryCode");
            // const CityName = localStorage.getItem("City") ? localStorage.getItem("City") : localStorage.getItem("Country");
            // navigate("/" + CountryCode + "/" + CityName, { state: { "login_popup": true } });
            setLogin(true);
        }
    }

    function capitalizeFirstLetter(string) {
        return string.replace(/\b\w/g, function (char) {
            return char.toUpperCase();
        });
    }

    const HandleBack = (e) => {
        const CountryCode = localStorage.getItem("CountryCode");
        const CityName = localStorage.getItem("City") ? localStorage.getItem("City") : localStorage.getItem("Country");
        navigate("/" + CountryCode + "/" + CityName);
    }
   
    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === "Escape") {
                setShareEventFlag(false);
            }
        };
        document.addEventListener("keydown", handleKeyPress);
        return () => {
            document.removeEventListener("keydown", handleKeyPress);
        };
    }, []);

    const handleEventDetails = (e, EventId, EventName) => {
        navigate("/e/"+EventName.replace(/\s/g, '_'));
    }

    return (
        <>
            {Loader ? <div><div id='loader' style={{ backgroundImage: `url(${LoaderImg})` }}></div></div> : null}
            <ToastContainer theme='colored' />
            <HeaderSecond Login={Login} setLogin={setLogin} />
            {ShareEventFlag ? <ShareEvent setShareEventFlag={setShareEventFlag} EventName={EventName} EventIdShareEvent={EventIdShareEvent} /> : null}

            {/* Start breadcrumb section */}
            <main className="main__content_wrapper">
                <section className="breadcrumb__section breadcrumb__bg" style={{ backgroundImage: `url(${BreadcrumbBg})` }} >
                    <div className="container">
                        <div className="row row-cols-1">
                            <div className="col">
                                <div className="breadcrumb__content">
                                    <h1 className="breadcrumb__content--title text-white mb-10">
                                        Favourites
                                    </h1>
                                    {/* <ul className="breadcrumb__content--menu d-flex">
                                        <li className="breadcrumb__content--menu__items">
                                            <div className="text-white">
                                                Home
                                            </div>
                                        </li>
                                        <li className="breadcrumb__content--menu__items">
                                            <span className="text-white">Favourites</span>
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-5">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xl-12 col-lg-8">
                                <div className="shop__header bg__gray--color d-flex align-items-center justify-content-between mb-30">
                                    <div className="product__view--mode__list product__short--by align-items-center d-lg-flex">
                                        <p className="product__showing--count">Showing {TotalUserEventFollow !== 0 ? 1 : 0}–{Index < TotalUserEventFollow ? Index : TotalUserEventFollow} of {TotalUserEventFollow} results</p>
                                    </div>


                                    <div className="product__view--mode__list product__short--by align-items-center d-lg-flex" title="Back to Home">
                                        <svg onClick={(e) => HandleBack(e)} className="back-to-home" xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 -960 960 960" width="30"><path d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z" /></svg>
                                    </div>
                                </div>

    <div className="shop__product--wrapper">
        {/* EVENTS LISTING TABLE START HERE */}
        <div className="tab_content">
            <div className="tab_pane active show">
                <div className='row py-4  px-3'>
                    {
                        UserEventsFollow.length > 0 ?

                            Array.isArray(UserEventsFollow) && UserEventsFollow.map((event) => (
                                <div className='col-12 col-sm-6 col-md-6 col-xl-3 col-xxl-3 py-3 ' style={{ paddingRight: '8px', paddingLeft: '8px' }}>
                                    <div key={event.id} className="product__items"
                                        onClick={(e) => handleEventDetails(e, event.id, event.name)}
                                    >

                                        <div className="product__items--thumbnail" >
                                            <div className="product__items--link">
                                                <img
                                                    className="product__items--img product__primary--img"
                                                    src={event.banner_image || EventView}
                                                    alt="Event View"
                                                    style={{ height: '230px', objectFit: 'fill' }}
                                                />
                                            </div>

                                            {/* New Event date */}
                                            <div className='event-date-card'>
                                                <p className="m-0 event-month-value">{event.start_event_month ? event.start_event_month : null}</p>
                                                <p className="m-0 event-date-value">{event.start_event_date ? event.start_event_date : null}</p>
                                            </div>

                                            <div className="product__badge style1 special-badge gap-1" >
                                                <svg xmlns="http://www.w3.org/2000/svg" height="15px" viewBox="0 -960 960 960" width="15px" fill="#323131ff"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" /></svg> {event.city_name}
                                            </div>


                                            {event.TicketDetails && event.TicketDetails.length > 0 && (
                                                event.TicketDetails.some(ticket => (parseInt(ticket.show_early_bird) === 1 && parseInt(ticket.ticket_status) !== 2)) ? (

                                                    <div className="product__badge_early_bird style1 special-badge gap-1" title='Early Bird'>
                                                        {/* Early Bird */}
                                                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="M480-80q-24 0-46-9t-39-26q-29-29-50-38t-63-9q-50 0-85-35t-35-85q0-42-9-63t-38-50q-17-17-26-39t-9-46q0-24 9-46t26-39q29-29 38-50t9-63q0-50 35-85t85-35q42 0 63-9t50-38q17-17 39-26t46-9q24 0 46 9t39 26q29 29 50 38t63 9q50 0 85 35t35 85q0 42 9 63t38 50q17 17 26 39t9 46q0 24-9 46t-26 39q-29 29-38 50t-9 63q0 50-35 85t-85 35q-42 0-63 9t-50 38q-17 17-39 26t-46 9Zm100-240q25 0 42.5-17.5T640-380q0-25-17.5-42.5T580-440q-25 0-42.5 17.5T520-380q0 25 17.5 42.5T580-320Zm-202-2 260-260-56-56-260 260 56 56Zm2-198q25 0 42.5-17.5T440-580q0-25-17.5-42.5T380-640q-25 0-42.5 17.5T320-580q0 25 17.5 42.5T380-520Z" /></svg>
                                                    </div>
                                                ) : null
                                            )}


                                        </div>


                                        {/* event info */}
                                        <div className="product__items--content cursor-pointer" >

                                            <div className=" pt-2">
                                                <h4 className="h4 d-flex" style={{ height: "55px", overflow: "hidden" }}>  {event.display_name}</h4>
                                            </div>

                                            {/* Location and like & share btn */}
                                            <div className="row d-flex align-items-center py-3" style={{ borderBottom: "1px dashed #c7c7c7" }}>
                                                <div className="col-sm-7">
                                                    {event.venue ?
                                                        <p className='card-rgn-txt overflow-text'> <strong>
                                                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#383434"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" /></svg> <span className="rgn-date">{event.venue}</span></strong>
                                                        </p>
                                                        : null}
                                                </div>

                                                <div className="col-sm-5 ps-0">
                                                    <ul className="product__items--action d-flex justify-content-end">

                                                        {/* Wishlist */}
                                                        <li className="product__items--action__list ">
                                                            <div className={event.is_follow ? "hand_cursor product__items--action__btn wishlisted" : "hand_cursor product__items--action__btn action-favourites"} onClick={(e) => {
                                                                e.stopPropagation(); // Stop event propagation
                                                                handleWishList(event.id, event.is_follow);
                                                            }}>


                                                                <svg className="product__items--action__btn--svg" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" transform="translate(0 0)" fill="currentColor"><path d="m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94 0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Z" /></svg>

                                                                <span className="visually-hidden">Favourites</span>
                                                            </div>
                                                        </li>

                                                        <li className="product__items--action__list">
                                                            <div className="product__items--action__btn hand_cursor action-share" onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleShareEvent(event.id, event.name)
                                                            }}>


                                                                <svg className="product__items--action__btn--svg" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" transform="translate(0 0)" fill="currentColor"><path d="M680-80q-50 0-85-35t-35-85q0-6 3-28L282-392q-16 15-37 23.5t-45 8.5q-50 0-85-35t-35-85q0-50 35-85t85-35q24 0 45 8.5t37 23.5l281-164q-2-7-2.5-13.5T560-760q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35q-24 0-45-8.5T598-672L317-508q2 7 2.5 13.5t.5 14.5q0 8-.5 14.5T317-452l281 164q16-15 37-23.5t45-8.5q50 0 85 35t35 85q0 50-35 85t-85 35Z" /></svg>


                                                                <span className="visually-hidden">Compare</span>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>


                                            {/* amount and action btn */}
                                            <div className="d-flex align-items-center justify-content-between py-3 px-2">

                                                <div className="">
                                                    {event.TicketDetails && event.TicketDetails.length > 0 ?
                                                        <h4 className="h4 d-flex align-items-center gap-1">
                                                            
                                                            {/* <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px" fill="currentColor"><path d="M549-120 280-400v-80h140q53 0 91.5-34.5T558-600H240v-80h306q-17-35-50.5-57.5T420-760H240v-80h480v80H590q14 17 25 37t17 43h88v80h-81q-8 85-70 142.5T420-400h-29l269 280H549Z" /></svg>

                                                            {event.TicketDetails && event.TicketDetails.length > 0 && (
                                                                event.TicketDetails.some(ticket => parseInt(ticket.ticket_status) === 2) ? (
                                                                    <span>Free</span>
                                                                ) : (

                                                                    event.TicketDetails.map((ticket, index) => (
                                                                        parseInt(ticket.ticket_status) === 1 && (
                                                                            <span key={index}>
                                                                              
                                                                                {ticket.show_early_bird === 1 ? (
                                                                                    <span > {ticket.ticket_price}</span>
                                                                                ) : (
                                                                                    <span>{ticket.ticket_price}</span>
                                                                                )}
                                                                            </span>
                                                                        )
                                                                    ))
                                                                )
                                                            )}
                                                            <small className="fw-normal fs-5 mt-1"> Onwards</small> */}

                                                            {event.TicketDetails && event.TicketDetails.length > 0 && (
                                                            event.TicketDetails.some(ticket => parseInt(ticket.ticket_status) === 2) ? (
                                                                <span className="current__price m-0">Free</span>
                                                            ) : (
                                                                event.TicketDetails.map((ticket, index) => (
                                                                parseInt(ticket.ticket_status) === 1 && (
                                                                    <span key={index}>
                                                                    {index > 0 && " - "}
                                                                    {ticket.show_early_bird === 1 ? (
                                                                        <span className="text-left">
                                                                        <span className="ticket-prices">
                                                                            <span className="original-price"> ₹{ticket.ticket_price}</span>&nbsp;
                                                                            <span className="current__price m-0">₹{ticket.discount_ticket_price}</span>
                                                                        </span>
                                                                        </span>
                                                                    ) : (
                                                                        <span className="current__price m-0">₹{ticket.ticket_price}</span>
                                                                    )}
                                                                    <small className="fw-normal fs-5 mt-1"> Onwards</small>
                                                                    </span>
                                                                )
                                                                ))
                                                            )
                                                            )}
                                                           </h4>
                                                        : null}
                                                </div>

                                                {event.registration_close_flag == 0 ?
                                                    <div className="">
                                                        <h4 className="h4 register-btn-link">Register Now <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" /></svg></h4>

                                                        <div className='product__items--action__btn hand_cursor register-btn-icon'> 
                                                            <svg className="product__items--action__btn--svg" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" transform="translate(0 0)" fill="currentColor"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" /></svg>
                                                        </div>
                                                    </div>
                                                    :
                                                    <p className="m-0 p-1 text-danger"><svg style={{ fill: "#dc3545" }} xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#dc3545"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q54 0 104-17.5t92-50.5L228-676q-33 42-50.5 92T160-480q0 134 93 227t227 93Zm252-124q33-42 50.5-92T800-480q0-134-93-227t-227-93q-54 0-104 17.5T284-732l448 448Z" /></svg> Registration Closed</p>
                                                }
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            ))

                            :
                            <>
                                <div className="product__section--inner py-5 text-center">
                                    {/* <img src={NoEventImg} alt="" style={{ width: 250 }} />
                                            <h4 className="pt-4">No events found</h4>
                                            <p>
                                                Sorry, We couldn't find any events that match your search, but here are some
                                                suggestions!
                                            </p> */}
                                </div>
                            </>
                    }
                </div>


            </div>
        </div>
        {/* END EVENTS LISTING TABLE START HERE */}

        {Index < UserEventsFollow.length ?
            <div className="pagination__area bg__gray--color" style={{cursor: 'pointer'}}>
                <nav className="pagination justify-content-center">
                    <div
                        className="continue__shipping--btn secondary__btn border-radius-5"
                        onClick={(e) => setIndex(Index + 5)}
                    >
                        Load more
                    </div>
                </nav>
            </div>
            : null
        }
    </div>

                            </div>
                        </div>
                    </div>
                </section>
            </main >
        </>
    );
}
export default ShowWishlist
